export const serializeWorkerWork = (workerWork) => ({
  ...workerWork,
  count: workerWork.count ? +workerWork.count : ""
});